module.exports = "<main class=\"main\" ui-view=\"main\"></main>\n<div class=\"popup-container\" id=\"PopupContainer\"></div>\n<div id=\"ModalContainer\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tpl.html
// module id = 1938
// module chunks = 0